module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('div', {
    attrs: {
      "id": "campaign-report"
    }
  }, [(_vm.reportData.campaign) ? _c('div', [_c('div', [_c('div', {
    staticClass: "hero-container"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/report/html-rpt-bg.jpg",
      "aspect-ratio": "1.7",
      "gradient": "to bottom right, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, .7)"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "client"
  }, [_c('v-img', {
    staticClass: "client-logo",
    attrs: {
      "src": _vm.reportData.campaign.client.logo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "client-name"
  }, [_vm._v(_vm._s(_vm.reportData.campaign.client.name))]), _vm._v(" "), _c('div', {
    staticClass: "current-date"
  }, [_vm._v(_vm._s(_vm.formatedCurrentDate))])], 1), _vm._v(" "), _c('div', {
    staticClass: "campaign"
  }, [_vm._v("\n                      " + _vm._s(_vm.reportData.campaign.name) + "\n                      "), _c('div', {
    staticClass: "objective-div"
  }, [_c('div', {
    staticClass: "objectives-title"
  }, [_vm._v("\n                          Objectives\n                          "), _c('ul', {
    staticClass: "objective"
  }, _vm._l((_vm.reportData.campaign.objectives), function(item, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n                                  " + _vm._s(item) + "\n                              ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "deliverable-title"
  }, [_vm._v("\n                          Deliverables\n                          "), _c('ul', {
    staticClass: "deliverable"
  }, _vm._l((_vm.reportData.campaign.deliverables), function(item, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n                                  " + _vm._s(item) + "\n                              ")])
  }), 0)])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#post"
    }
  }, [_c('div', {
    staticClass: "scroll"
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sideNavContents"
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "max-width": "180"
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "mini-variant": _vm.mini,
      "permanent": "",
      "right": "",
      "expand-on-hover": "",
      "dark": ""
    },
    on: {
      "update:miniVariant": function($event) {
        _vm.mini = $event
      },
      "update:mini-variant": function($event) {
        _vm.mini = $event
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    attrs: {
      "color": "#212121",
      "dense": ""
    }
  }, [_c('v-list-item', {
    attrs: {
      "link": "",
      "href": "#campaignSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('v-icon', [_vm._v("mdi-file-check")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Campaign Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enablePostAnalysis && _vm.postsAnalysisData.length > 0),
      expression: "reportData.campaign.enablePostAnalysis && postsAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#postSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('v-icon', [_vm._v("mdi-image-multiple")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Post Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enableReelAnalysis && _vm.reelAnalysisData.length > 0),
      expression: "reportData.campaign.enableReelAnalysis && reelAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#reelSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('v-icon', [_vm._v("mdi-movie-roll")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Reel Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storyAnalysisData.length > 0),
      expression: "storyAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#storySummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('v-icon', [_vm._v("mdi-movie-open")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Story Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enableTikTokAnalysis && _vm.tikTokAnalysisData.length > 0),
      expression: "reportData.campaign.enableTikTokAnalysis && tikTokAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#tiktokSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/tik-tok-white.png",
      "aspect-ratio": "1"
    }
  })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("TikTok Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enableYoutubeAnalysis && _vm.youtubeAnalysisData.length > 0),
      expression: "reportData.campaign.enableYoutubeAnalysis && youtubeAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#youtubeSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('i', {
    staticClass: "fab fa-youtube",
    staticStyle: {
      "font-size": "25px"
    }
  })]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Youtube Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enableFbAnalysis && _vm.fbAnalysisData.length > 0),
      expression: "reportData.campaign.enableFbAnalysis && fbAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#fbSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('i', {
    staticClass: "fab fa-facebook",
    staticStyle: {
      "font-size": "25px"
    }
  })]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Facebook Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enableLinkedInAnalysis && _vm.linkedInAnalysisData.length > 0),
      expression: "reportData.campaign.enableLinkedInAnalysis && linkedInAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#linkedInSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('v-icon', [_vm._v("mdi-linkedin")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("LinkedIn Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enableTwitterAnalysis && _vm.twitterAnalysisData.length > 0),
      expression: "reportData.campaign.enableTwitterAnalysis && twitterAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#twitterSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('span', {
    staticClass: "report-nav-x-logo",
    attrs: {
      "role": "img",
      "aria-label": "X (Twitter)"
    }
  })]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("X (Twitter) Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enableXHSAnalysis && _vm.xhsAnalysisData.length > 0),
      expression: "reportData.campaign.enableXHSAnalysis && xhsAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#xhsSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('v-icon', [_vm._v("mdi-file-outline")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("XHS Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enableLemonAnalysis && _vm.lemonAnalysisData.length > 0),
      expression: "reportData.campaign.enableLemonAnalysis && lemonAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#lemonSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('v-icon', [_vm._v("mdi-file-outline")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Lemon8 Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enableOverallSection),
      expression: "reportData.campaign.enableOverallSection"
    }],
    attrs: {
      "link": "",
      "href": "#performance"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('v-icon', [_vm._v("mdi-chart-bar")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Overall")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "fab-btn-up",
    attrs: {
      "id": "goTop",
      "elevation": "24",
      "color": "#3F3FFF",
      "fab": "",
      "small": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "raised": ""
    },
    on: {
      "click": _vm.scrollTopFunction
    }
  }, [_c('v-icon', [_vm._v("mdi-menu-up")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "campaignSummary"
    }
  }, [_c('campaign-summary', {
    attrs: {
      "campaign": _vm.reportData.campaign
    }
  })], 1), _vm._v(" "), (_vm.reportData.campaign.enablePostAnalysis && _vm.postsAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "postSummary"
    }
  }, [_c('post-summary', {
    attrs: {
      "posts": _vm.postsAnalysisData,
      "campaign": _vm.reportData.campaign
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableReelAnalysis && _vm.reelAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "reelSummary"
    }
  }, [_c('reel-summary', {
    attrs: {
      "posts": _vm.reelAnalysisData,
      "campaign": _vm.reportData.campaign
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.storyAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "storySummary"
    }
  }, [_c('story-summary', {
    attrs: {
      "posts": _vm.storyAnalysisData,
      "campaign": _vm.reportData.campaign
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableTikTokAnalysis && _vm.tikTokAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "tiktokSummary"
    }
  }, [_c('tiktok-summary', {
    attrs: {
      "posts": _vm.tikTokAnalysisData,
      "campaign": _vm.reportData.campaign
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableYoutubeAnalysis && _vm.youtubeAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "youtubeSummary"
    }
  }, [_c('youtube-summary', {
    attrs: {
      "posts": _vm.youtubeAnalysisData,
      "campaign": _vm.reportData.campaign
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableFbAnalysis && _vm.fbAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "fbSummary"
    }
  }, [_c('fb-summary', {
    attrs: {
      "posts": _vm.fbAnalysisData,
      "campaign": _vm.reportData.campaign
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableLinkedInAnalysis && _vm.linkedInAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "linkedInSummary"
    }
  }, [_c('fb-summary', {
    attrs: {
      "summaryType": "linkedin",
      "posts": _vm.linkedInAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultLinkedInAnalysisStatus
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableTwitterAnalysis && _vm.twitterAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "twitterSummary"
    }
  }, [_c('fb-summary', {
    attrs: {
      "summaryType": "twitter",
      "posts": _vm.twitterAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultTwitterAnalysisStatus
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableXHSAnalysis && _vm.xhsAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "xhsSummary"
    }
  }, [_c('xhs-summary', {
    attrs: {
      "posts": _vm.xhsAnalysisData,
      "campaign": _vm.reportData.campaign
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableLemonAnalysis && _vm.lemonAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "lemonSummary"
    }
  }, [_c('lemon-summary', {
    attrs: {
      "posts": _vm.lemonAnalysisData,
      "campaign": _vm.reportData.campaign
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableOverallSection) ? _c('section', {
    attrs: {
      "id": "performance"
    }
  }, [_c('campaign-performance', {
    attrs: {
      "posts": _vm.postsAnalysisData,
      "reels": _vm.reelAnalysisData,
      "tikTokPosts": _vm.tikTokAnalysisData,
      "youtubePosts": _vm.youtubeAnalysisData,
      "summary": _vm.reportData.campaign.summary,
      "campaignID": _vm.reportData.campaign.id,
      "campaignKPI": _vm.reportData.campaign.kpi,
      "campaign": _vm.reportData.campaign
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "post"
    }
  }, _vm._l((_vm.campaignPosts), function(item, index) {
    return _c('div', {
      key: index
    }, [(item.reportGroup && item.reports.length > 0) ? _c('div', [_c('v-container', [_c('v-expansion-panels', {
      attrs: {
        "multiple": "",
        "dark": "",
        "accordion": "",
        "focusable": ""
      },
      model: {
        value: (item.panel),
        callback: function($$v) {
          _vm.$set(item, "panel", $$v)
        },
        expression: "item.panel"
      }
    }, [_c('v-expansion-panel', {
      attrs: {
        "expand": ""
      }
    }, [_c('v-expansion-panel-header', [_c('v-toolbar-title', [_vm._v("\n                            " + _vm._s(item.name) + " (" + _vm._s(item.reports.length) + ")\n                          ")])], 1), _vm._v(" "), _c('v-expansion-panel-content', _vm._l((item.reports), function(item2, index) {
      return _c('posts', {
        key: index,
        attrs: {
          "type": item2.type,
          "post": item2,
          "campaign": _vm.reportData.campaign
        }
      })
    }), 1)], 1)], 1)], 1)], 1) : _c('div', [_c('posts', {
      key: index,
      attrs: {
        "type": item.type,
        "post": item,
        "campaign": _vm.reportData.campaign
      }
    })], 1)])
  }), 0), _vm._v(" "), _c('v-footer', {
    staticClass: "report-footer",
    attrs: {
      "padless": "",
      "color": "#000000"
    }
  }, [_c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "72px",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.kobeGreenLogo,
      "width": "72px"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": "https://www.getkobe.com",
      "target": "_blank"
    }
  }, [_vm._v("www.getkobe.com")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('report-login-modal', {
    attrs: {
      "value": _vm.loginModalDialog,
      "campaignID": _vm.campaignID
    },
    on: {
      "loggedIn": _vm.loggedIn
    },
    model: {
      value: (_vm.loginModalDialog),
      callback: function($$v) {
        _vm.loginModalDialog = $$v
      },
      expression: "loginModalDialog"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e5de260"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/index.vue
// module id = 2248
// module chunks = 0